import type { BannerConfig } from "./announcement-banner";

export const bannerConfig: BannerConfig = {
	actions: [
		{
			href: "/mangomap-v4",
			label: "See what's new",
			variant: "outlined",
		},
	],
	enabled: true,
	color: "success", // info | success | warning | error
	variant: "filled", // standard | outlined | filled
	id: "mangomap-v4-launch",
	message: "MangoMap v4 is here. Sign in to explore.",
};
